<jbm-modal [id]="'user-preferences'" [className]="'user-preferences'" (onClose)="close()"></jbm-modal>
<ng-template #modalUserPreferences let-modal>
  <form [formGroup]="form" (ngSubmit)="save()" xmlns="http://www.w3.org/1999/html">
    <div class="jbm-modal-header">
      <div class="jbm-crud-title">
        <div class="title">
          {{title}}
        </div>
      </div>
      <div class="toolbar float-end">
        <jbm-help-button [class]="'light'" [helpTopicID]="0"></jbm-help-button>
        <div class="toolbar-spacer-1"></div>
        <jbm-cross-close-button (onClick)="close()"></jbm-cross-close-button>
      </div>
    </div>
    <div class="jbm-modal-body">
        <jbm-select [formControl]="formControls.IDdisplay" [options]="entityIDdisplayOptions" [submitted]="isSubmitted" 
          [id]="'IDdisplay'" labelCaption="{{'preferences.entity-id-display'|translate}}" 
          labelClass="width-11" class="input-15" (onChange)="changeEntityIDdisplay($event)">
          <div class="float-start ms-2">
            <label>{{'ui.preview'|translate}}</label>: 
            <jbm-label-with-ID [ID]="123" label="{{'entity.project'|translate}}{{'entity.name'|translate|lowercase}}" [IDPosition]="preferences.display.IDdisplay"></jbm-label-with-ID>
          </div>
        </jbm-select>
    </div>
    <div class="jbm-modal-footer">
      <div class="toolbar float-end">
        <jbm-save-button [subject]="title" (click)="save()"></jbm-save-button>
        <div class="toolbar-spacer-1"></div>
        <jbm-cancel-button (click)="close()"></jbm-cancel-button>
      </div>
    </div>
  </form>
</ng-template>